export let exitSearchTitle = "IOFH$c";
export let suggestionsAnnouncementSingular = "dVr7_d";
export let suggestionsAnnouncementPlural = "G3bqwe";
export let searchButtonTitle = "YITPCc";
export let searchTooltipTitle = "v8Q3$c";
export default {exitSearchTitle,suggestionsAnnouncementSingular,suggestionsAnnouncementPlural,searchButtonTitle,searchTooltipTitle};